import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'reactstrap';
import { Redirect } from "react-router-dom";
import ProgrammationGroupForm from '../ProgrammationGroupForm/ProgrammationGroupForm';
import { PageTitle } from '../../../components';
import { useTranslation } from 'react-i18next';
import { startCreateProgrammationGroup, createProgrammationGroup, getNoAbilityInfos } from '../../../redux';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { Utils } from '../../../services';
import i18n from '../../../locales/i18n';

const ProgrammationsGroupCreate = ({}) => {
    const [ initialized, setInitialized] = useState(false);

    const {
        isLoading,
        programmation_groupSuccessfullyCreated,
        programmation_group
    }                    = useSelector(state => state.programmation_groups);
    const events         = useSelector(state => state.programmation_groups.linkedResources.events);
    const bucketlists    = useSelector(state => state.programmation_groups.linkedResources.bucketlists);
    const dispatch       = useDispatch();
    const { t }          = useTranslation();
    let   { events_ids } = useParams();

    useEffect(() => {
        if (!initialized && bucketlists) {
            setInitialized(true);
            dispatch(startCreateProgrammationGroup(bucketlists));
        }
    }, [bucketlists])

    const submit = (values) => {
        if (!values?.events?.length && !values.new_event) {
            if (events_ids) {
                events_ids = events_ids.split(',');
                if (events_ids.length)
                    values.new_event = events_ids[0];
            }
        }
        dispatch(createProgrammationGroup(values, {}, (err, programmation_group) => {
            /*if (!err && programmation_group)
                window.location.href = `/programmation_groups/edit/${programmation_group.id}`;*/
        }));
    }

    const goBack = () => {
        window.history.back();
    }

    let title =
        <span>
            {t('programmations.add')}
            {(events && events.length > 0) ? " - " + Utils.localized_or_fallback(events?.find(e => e.id === events_ids)?.title, i18n.language) : ""}
        </span>;

    const actions =
        <Button onClick={goBack} color="warning" size="sm">
            <i className="fa fa-arrow-left"></i>&nbsp;{ t('common.back')}
        </Button>

    return (
        <div className="ProgrammationsGroupCreate">
            <PageTitle icon="th" title={ title } actions={ actions } />

            {programmation_group && programmation_groupSuccessfullyCreated &&
                <Redirect to={`/programmation_groups/edit/${programmation_group.id}`} />
            }

            <ProgrammationGroupForm onSubmit={submit} isCreation events_ids={events_ids} />
        </div>
    );
}

export default ProgrammationsGroupCreate;
